import { Link } from "react-router-dom";
import { socialLinks, ETSY_SHOP_URL } from "@/data/products";

const linkClass =
  "text-[12px] tracking-[0.22em] uppercase text-[#a89b8c] hover:text-[#c28b46] link-underline";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#141010] border-t border-[#362b28] pt-24 md:pt-40 pb-14"
      data-testid="site-footer"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        {/* Massive brand mark */}
        <div className="mb-16 md:mb-24 flex items-end gap-8">
          <img
            src="/brand/eta-logo.jpg"
            alt="Earth Tone Archetypes"
            className="w-24 h-24 md:w-32 md:h-32 object-cover border border-[#c28b46]/40 shrink-0"
          />
          <h3 className="font-serif text-[#2a201d] text-[64px] sm:text-[120px] md:text-[200px] lg:text-[240px] leading-[0.85] tracking-[-0.03em]">
            EarthTone.
          </h3>
        </div>

        <div className="grid grid-cols-12 gap-8 pb-16 border-b border-[#362b28]">
          <div className="col-span-12 md:col-span-5">
            <p className="eyebrow mb-4">The Movement</p>
            <p className="font-serif text-[22px] md:text-[26px] leading-snug text-[#e8dcc4] max-w-[38ch]">
              <em className="italic text-[#c28b46]">Wear Your Truth.</em> Formed from the dust of the earth. Genesis 2:7.
            </p>
            <a
              href={ETSY_SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-terra mt-8 inline-flex"
              data-testid="footer-etsy-cta"
            >
              Shop Etsy Store →
            </a>
          </div>

          <div className="col-span-6 md:col-span-3 md:col-start-7">
            <p className="text-[10px] tracking-[0.32em] uppercase text-[#c28b46] mb-6">
              Explore
            </p>
            <ul className="space-y-4">
              <li>
                <Link to="/" className={linkClass} data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className={linkClass} data-testid="footer-about">
                  About
                </Link>
              </li>
              <li>
                <a href="/#shop" className={linkClass} data-testid="footer-shop">
                  Collection
                </a>
              </li>
              <li>
                <a href="/#guide" className={linkClass} data-testid="footer-guide">
                  Free Guide
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-[10px] tracking-[0.32em] uppercase text-[#c28b46] mb-6">
              Follow The Movement
            </p>
            <ul className="space-y-4">
              <li>
                <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="footer-instagram">
                  Instagram
                </a>
              </li>
              <li>
                <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="footer-tiktok">
                  TikTok
                </a>
              </li>
              <li>
                <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="footer-youtube">
                  YouTube
                </a>
              </li>
              <li>
                <a href={socialLinks.x} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="footer-x">
                  X (Twitter)
                </a>
              </li>
              <li>
                <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="footer-facebook">
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 grid grid-cols-12 gap-4 text-[11px] tracking-[0.22em] uppercase text-[#8a7a6a]">
          <p className="col-span-12 md:col-span-6">
            © {new Date().getFullYear()} Earth Tone Original Skin. All rights reserved.
          </p>
          <p className="col-span-12 md:col-span-6 md:text-right">
            earthtoneoriginalskin.org · Est. Dust of the Earth
          </p>
        </div>
      </div>
    </footer>
  );
}
